import emailMask from 'text-mask-addons/dist/emailMask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
//TODO alterar nome dessa classe
export class CDSMask {

  telefonePlaceholder = '(__) ____-_____';
  cepPlaceholder = '_____-___';
  dataPlaceholder = '__/__/____';
  horaPlaceholder = '  :  ';
  ddiPaises: any

ddi(ddiP): any {
  this.ddiPaises = ddiP
}
  celular(): any {
    return {
      mask: (userInput, config) => {
        return this.telefoneMask(userInput, config, this.ddiPaises)
      },
      placeholderChar: '\u2000',
    };
  }

  telefone(): any {
    return {
      mask: this.telefoneMask,
      placeholderChar: '\u2000',
    };
  }

  private telefoneMask(userInput, config, ddiP) {
    const numbers = userInput.match(/\d/g);
    let numberLength = 0;
    if (numbers) {
      numberLength = numbers.join('').length;
    }
    if(ddiP == null || ddiP == undefined) {
      ddiP = '+55'
    }
    if(ddiP === '+55'){
      if (numberLength > 10) {
        return ['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      } else {
        return ['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      }
    }
    if(ddiP != null || undefined){
      return [ddiP, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/];
    }
      if (numberLength > 10) {
        return ['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      } else {
        return ['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      }
  }

  cpfCnpjPlaceholder(tipo: string) {
    if (tipo === 'F') {
      return '___.___.___-__';
    } else {
      return '__.___.___/____-__';
    }
  }

  cpfCnpj(): any {
    return {
      mask: this.cpfCnpjMask,
      placeholderChar: '\u2000'
    };
  }

  private cpfCnpjMask(userInput, config) {
    const numbers = userInput.match(/\d/g);
    let numberLength = 0;
    if (numbers) {
      numberLength = numbers.join('').length;
    }
    if (numberLength > 11) {
      return [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    } else {
      return [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    }
  }

  cep(): any {
    return {
      mask: (userInput, config) => {
        return [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
      },
      placeholderChar: '\u2000'
    };
  }


  data(): any {
    return {
      mask: (userInput, config) => {
        return [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
      },
      placeholderChar: '\u2000',
      pipe: createAutoCorrectedDatePipe('dd/mm/yyyy')
    };
  }

  hora(): any {
    return {
      mask: (userInput, config) => {
        return [/[0-2]/, /\d/, ':', /[0-6]/, /\d/];
      },
      placeholderChar: '\u2000',
    };
  }

  email(): any {
    return {
      mask: emailMask,
      placeholderChar: '\u2000',
    };
  }

  int(): any {
    return {
      mask: (userInput, config) => {
        return [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
      },
      placeholderChar: '\u2000',
    };
  }

  porcentual(): any {
    return { mask: [/[0-9]/, /[0-9]/, ',', /[0-9]/, /[0-9]/, ' %'] };
  }

  decimal(): any {
    return { prefix: '', suffix: ' %', thousands: '', decimal: ',', allowNegative: 'false' };
  }
}
